var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHmrc = function SvgHmrc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.1,
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#101828",
    strokeWidth: 2,
    d: "M14 10.13V21.8c0 .11.09.2.2.2h5.166a.2.2 0 0 0 .186-.127c4.413-10.855 2.773-15.489-5.43-11.927a.2.2 0 0 0-.122.184ZM9.94 10.13V21.8a.2.2 0 0 1-.2.2H4.576a.2.2 0 0 1-.186-.127C-.024 11.018 1.616 6.384 9.82 9.946a.2.2 0 0 1 .122.184Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 1,
    fill: "#101828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#101828",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M12 1v4M10 3h4"
  })));
};
export default SvgHmrc;